<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import SalesDetailFactList from './SalesDetailFactList.vue';

const props = defineProps({ manager: { type: Object, required: true } });
const { t } = useI18n();
const address = computed(() => props.manager.profile?.address || {});
const items = computed(() => [
  { key: 'cep', label: t('SALES_PARTIES.FORM.CEP'), value: address.value.cep },
  {
    key: 'street',
    label: t('SALES_PARTIES.FORM.STREET'),
    value: address.value.street,
  },
  {
    key: 'number',
    label: t('SALES_PARTIES.FORM.NUMBER'),
    value: address.value.number,
  },
  {
    key: 'unit',
    label: t('SALES_PARTIES.FORM.UNIT'),
    value: address.value.unit,
  },
  {
    key: 'complement',
    label: t('SALES_PARTIES.FORM.COMPLEMENT'),
    value: address.value.complement,
  },
  {
    key: 'city',
    label: t('SALES_PARTIES.FORM.CITY'),
    value: address.value.city,
  },
  {
    key: 'state',
    label: t('SALES_PARTIES.FORM.STATE'),
    value: address.value.state,
  },
  {
    key: 'neighborhood',
    label: t('SALES_PARTIES.FORM.NEIGHBORHOOD'),
    value: address.value.neighborhood,
  },
]);
</script>

<template>
  <LaisCard
    :title="t('SALES.DETAIL.MANAGER_ADDRESS.TITLE')"
    prefix-icon="i-lucide-map-pin"
  >
    <SalesDetailFactList :items="items" />
  </LaisCard>
</template>
